import { calcResourceGatherTime } from '../../data';
import { makeResources } from '../../resources';
import { StateFastForward } from '../core';
import { makeTimelineEntry, makeInvalidEntry } from '../timelineEntries';
import { captureStateSnapshot } from '../snapshot';
import { drainShorterThan } from '../waits';
import { addFleetAction } from '../schedule';

export const handleTransport = (state, timeline, recorder, action, index) => {
  const { payload } = action;
  const { planetId, settings } = payload;

  const cost = makeResources(settings.metal, settings.crystal, settings.deuterium);
  let gatherTime = calcResourceGatherTime(state, planetId, { ...cost });
  if (gatherTime < 0) {
    timeline.push(makeInvalidEntry(state, planetId, index, 'Start Transport'));
    return state;
  }

  const drained = drainShorterThan(state, timeline, recorder, planetId, gatherTime, (s) =>
    calcResourceGatherTime(s, planetId, { ...cost })
  );
  state = drained.state;
  gatherTime = drained.threshold;

  if (gatherTime > 0) {
    const beforeGatherState = captureStateSnapshot(state, planetId);
    timeline.push(makeTimelineEntry('gather', state, { ...action, duration: gatherTime, index }, beforeGatherState));
    state = StateFastForward(state, planetId, gatherTime, recorder);
    timeline[timeline.length - 1].stateAfter = captureStateSnapshot(state, planetId);
  }

  const beforeTransportState = captureStateSnapshot(state, planetId);
  state.planets[planetId].resources.metal -= settings.metal;
  state.planets[planetId].resources.crystal -= settings.crystal;
  state.planets[planetId].resources.deuterium -= settings.deuterium;
  // eslint-disable-next-line eqeqeq
  if (settings.target != 0) {
    addFleetAction(state, state.planets[planetId].time, settings.target, {
      ...action,
      duration: settings.flight_time,
      index,
    });
  }
  const afterTransportState = captureStateSnapshot(state, planetId);

  recorder.record(
    state,
    planetId,
    `Started transport to Planet ${settings.target} (M:${settings.metal}, C:${settings.crystal}, D:${settings.deuterium})`
  );

  timeline.push(
    makeTimelineEntry('start', state, { ...action, duration: settings.extra_wait, index }, beforeTransportState, afterTransportState)
  );

  return state;
};
